import React, { useEffect, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function BookingConfirm() {
  const { slug } = useParams();
  const [params] = useSearchParams();
  const [state, setState] = useState("checking"); // checking | paid | failed

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setState("failed"); return; }
    let tries = 0;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (data.status === "expired" || tries > 10) { setState("failed"); return; }
      } catch { if (tries > 10) { setState("failed"); return; } }
      setTimeout(poll, 2000);
    };
    poll();
  }, [params]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-secondary/40 px-6">
      <div className="text-center max-w-md">
        {state === "checking" && (<><Loader2 size={40} className="animate-spin mx-auto text-primary mb-4" /><h1 className="font-display text-2xl font-bold">Confirming your payment…</h1><p className="text-muted-foreground mt-2">One moment please.</p></>)}
        {state === "paid" && (<>
          <div className="w-16 h-16 rounded-full bg-[hsl(var(--success))]/15 text-[hsl(var(--success))] flex items-center justify-center mx-auto mb-6"><CheckCircle2 size={34} /></div>
          <h1 className="font-display text-3xl font-bold">Deposit received!</h1>
          <p className="text-muted-foreground mt-2 mb-8">Your appointment is confirmed. We've emailed you the details and will remind you before your visit.</p>
          <Link to={`/book/${slug}`}><Button className="bg-primary text-primary-foreground hover:bg-primary/90" data-testid="confirm-book-again">Book another appointment</Button></Link>
        </>)}
        {state === "failed" && (<>
          <div className="w-16 h-16 rounded-full bg-destructive/10 text-destructive flex items-center justify-center mx-auto mb-6"><XCircle size={34} /></div>
          <h1 className="font-display text-2xl font-bold">Payment not completed</h1>
          <p className="text-muted-foreground mt-2 mb-8">Your deposit wasn't confirmed. Please try booking again.</p>
          <Link to={`/book/${slug}`}><Button className="bg-primary text-primary-foreground hover:bg-primary/90" data-testid="confirm-retry">Try again</Button></Link>
        </>)}
      </div>
    </div>
  );
}
